import {
  GET_ACTION_PLAN_CATEGORIES, GET_ACTION_PLAN_CATEGORIES_SUCCESS, GET_ACTION_PLAN_CATEGORIES_FAIL,
  ADD_ACTION_PLAN_CATEGORY, ADD_ACTION_PLAN_CATEGORY_SUCCESS, ADD_ACTION_PLAN_CATEGORY_ERROR,
  UPDATE_ACTION_PLAN_CATEGORY, UPDATE_ACTION_PLAN_CATEGORY_SUCCESS, UPDATE_ACTION_PLAN_CATEGORY_FAIL,
  DELETE_ACTION_PLAN_CATEGORY, DELETE_ACTION_PLAN_CATEGORY_SUCCESS, DELETE_ACTION_PLAN_CATEGORY_ERROR,
  GET_ACTION_PLANS, GET_ACTION_PLANS_SUCCESS, GET_ACTION_PLANS_FAIL,
  GET_ALL_ACTION_PLANS, GET_ALL_ACTION_PLANS_SUCCESS, GET_ALL_ACTION_PLANS_FAIL,
  GET_ACTION_PLAN_DETAIL, GET_ACTION_PLAN_DETAIL_SUCCESS, GET_ACTION_PLAN_DETAIL_FAIL, CLEAR_ACTION_PLAN_DETAIL,
  ADD_UPDATE_ACTION_PLAN, ADD_UPDATE_ACTION_PLAN_SUCCESS, ADD_UPDATE_ACTION_PLAN_ERROR,
  DELETE_ACTION_PLAN, DELETE_ACTION_PLAN_SUCCESS, DELETE_ACTION_PLAN_ERROR,
} from "./actionTypes"

//Categories (Folders)

export const getActionPlanCategories = agentId => ({
  type: GET_ACTION_PLAN_CATEGORIES,
  agentId,
})

export const getActionPlanCategoriesSuccess = categories => ({
  type: GET_ACTION_PLAN_CATEGORIES_SUCCESS,
  payload: categories,
})

export const getActionPlanCategoriesFail = error => ({
  type: GET_ACTION_PLAN_CATEGORIES_FAIL,
  payload: error,
})

export const addActionPlanCategory = (category, callback) => ({
  type: ADD_ACTION_PLAN_CATEGORY,
  payload: { category, callback },
})

export const addActionPlanCategorySuccess = category => ({
  type: ADD_ACTION_PLAN_CATEGORY_SUCCESS,
  payload: category,
})

export const addActionPlanCategoryError = error => ({
  type: ADD_ACTION_PLAN_CATEGORY_ERROR,
  payload: error,
})

export const updateActionPlanCategory = (category, callback) => ({
  type: UPDATE_ACTION_PLAN_CATEGORY,
  payload: { category, callback },
})

export const updateActionPlanCategorySuccess = category => ({
  type: UPDATE_ACTION_PLAN_CATEGORY_SUCCESS,
  payload: category,
})

export const updateActionPlanCategoryFail = error => ({
  type: UPDATE_ACTION_PLAN_CATEGORY_FAIL,
  payload: error,
})

export const deleteActionPlanCategory = category => ({
  type: DELETE_ACTION_PLAN_CATEGORY,
  payload: category,
})

export const deleteActionPlanCategorySuccess = category => ({
  type: DELETE_ACTION_PLAN_CATEGORY_SUCCESS,
  payload: category,
})

export const deleteActionPlanCategoryError = error => ({
  type: DELETE_ACTION_PLAN_CATEGORY_ERROR,
  payload: error,
})

//Action Plans

export const getActionPlans = (agentId, folder) => ({
  type: GET_ACTION_PLANS,
  agentId,
  folder,
})

export const getActionPlansSuccess = plans => ({
  type: GET_ACTION_PLANS_SUCCESS,
  payload: plans,
})

export const getActionPlansFail = error => ({
  type: GET_ACTION_PLANS_FAIL,
  payload: error,
})

export const getAllActionPlans = agentId => ({
  type: GET_ALL_ACTION_PLANS,
  agentId,
})

export const getAllActionPlansSuccess = plans => ({
  type: GET_ALL_ACTION_PLANS_SUCCESS,
  payload: plans,
})

export const getAllActionPlansFail = error => ({
  type: GET_ALL_ACTION_PLANS_FAIL,
  payload: error,
})

export const getActionPlanDetail = id => ({
  type: GET_ACTION_PLAN_DETAIL,
  id,
})

export const getActionPlanDetailSuccess = plan => ({
  type: GET_ACTION_PLAN_DETAIL_SUCCESS,
  payload: plan,
})

export const getActionPlanDetailFail = error => ({
  type: GET_ACTION_PLAN_DETAIL_FAIL,
  payload: error,
})

export const clearActionPlanDetail = () => ({
  type: CLEAR_ACTION_PLAN_DETAIL,
})

export const addUpdateActionPlan = (plan, callback) => ({
  type: ADD_UPDATE_ACTION_PLAN,
  payload: { plan, callback },
})

export const addUpdateActionPlanSuccess = plan => ({
  type: ADD_UPDATE_ACTION_PLAN_SUCCESS,
  payload: plan,
})

export const addUpdateActionPlanError = error => ({
  type: ADD_UPDATE_ACTION_PLAN_ERROR,
  payload: error,
})

export const deleteActionPlan = plan => ({
  type: DELETE_ACTION_PLAN,
  payload: plan,
})

export const deleteActionPlanSuccess = plan => ({
  type: DELETE_ACTION_PLAN_SUCCESS,
  payload: plan,
})

export const deleteActionPlanError = error => ({
  type: DELETE_ACTION_PLAN_ERROR,
  payload: error,
})
